/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DataPickerService } from '../../core/services/data_picker/data_picker.service';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { MyCustomPaginatorIntl } from '../../core/services/paginator_service/my-paginator.service';
import { pickerConfig } from 'assets/picker_config';
import { PickerOptions, PickerSelectOptions } from './data-picker.interface';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { BadgeOptions } from '../badge/badge.interface';
import { DateRangeComponent } from '../date-range/date-range.component';
import dayjs from 'dayjs';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { concat, Observable, of, Subject } from 'rxjs';
import _ from 'lodash';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { HotToastService } from '@ngneat/hot-toast';
import { assetStatus, moduleKey } from '../../core/constants/constants';
import { v4 as uuidv4 } from 'uuid';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { CustomersService } from 'app/core/services/customers/customers.service';
import { PropertyService } from 'app/core/services/properties/properties.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';

@Component({
  selector: 'data-picker',
  templateUrl: './data-picker.component.html',
  styleUrls: ['./data-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }]
})
export class DataPickerComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() openPicker: boolean = false;
  @Input() module: string = '';
  @Input() options: PickerOptions = {
    position: '',
    mode: '',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: false,
    selectOption: PickerSelectOptions.select,
    fromModule: '',
    showPreSelectedValue: false
  };
  @Input() filter: any = null;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() pickerDrawerName: string = ''; //We can set unqiue name for data picker drawer
  @Input() timezone?: string;
  @ViewChild('searchField') searchField: ElementRef;

  uuid: string;
  drawerName: string = 'dataPicker';
  viewMode: string = '';
  searchKey: string = '';
  pagination: any = {
    totalRecords: -1,
    pageIndex: 0,
    pageSize: 10
  };
  baseUrl: any = `${this.dataCollectorService.baseurl()}`;
  dataUrl: any = '';
  selectedValue: any[] = [];
  tabs: any[] = [];
  pickerConfig: any = pickerConfig;
  showSelectedItems: boolean = false;

  eventSearchKey: string = '';
  eventPageIndex: number = 0;
  eventFormReset: boolean = false;
  eventSubmit: boolean = false;
  eventSortBy: string;
  eventSortType: string;
  eventListData: any[] = null;
  eventMaxSelect: boolean = false;

  //Custom Tab
  customTabSearchKey: string = '';
  footerCheckboxValue: boolean = false;

  //Filter
  filterFormGroup: UntypedFormGroup = null;
  filterVisible: boolean = false;
  selectedDateRange: { startDate: any; endDate: any } = null;
  jobAssignedTypes: any[] = [{
    type: 'ASSIGNED',
    displayKey: 'datapicker.job_assigned.assigned_text'
  }, {
    type: 'UNASSIGNED',
    displayKey: 'text.unassigned_jobs'
  }];
  jobCategory: any[] = [];
  //Assign Employee Lookup
  listValue$: Observable<any[]> = new Observable<any[]>();
  preloadedValue: any = [];
  valueSubject$: Subject<string | null> = new Subject<string | null>();
  lookupLoading: boolean = false;
  pageSize: number = 1;
  totalPages: number;
  searchTerm: string = '';
  //Asset Status
  assetStatus: { key: string; value: string }[] = assetStatus;
  //Filter By
  moduleBasedFilter!: NgSelectComponent;
  recurringJobInfoBubble: any;
  timeoutId: any = null;
  preSelectedValue: string;
  preSelectedValuesIcon: string;
  @ViewChild('module_based_filter') set selectInstance(content: NgSelectComponent) {
    if (content) { // initially setter gets called with undefined
      this.moduleBasedFilter = content;
    }
  }
  filterByMenuList: any[] = [];
  selectedModuleFilter: any = null;
  moduleFilterListValue$: Observable<any[]> = new Observable<any[]>();
  moduleFilterPreloadedValue: any = [];
  moduleFilterValueSubject$: Subject<string | null> = new Subject<string | null>();
  filterLookupLoading: boolean = false;
  moduleFilterPageIndex: number = 1;
  moduleFilterTotalPageCount: number;
  moduleFilterSearchTerm: string = '';
  isInitialVisibilityChange: boolean = true;
  selectedModuleFilterValue: any = null;
  hasFilterValue: boolean = false;
  isDrawerOpened: boolean = false;
  isCategoryEnabled: boolean = false;
  isButtonDisabled: boolean = false;
  previousValueUids: string[] = [];
  selectedValueUids: string[] = [];

  constructor(
    private zuperDrawerService: ZuperDrawerService,
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private pickerService: DataPickerService,
    private zuperDialogService: ZuperDialogService,
    private cdRef: ChangeDetectorRef,
    private toast: HotToastService,
    private utilityService: UtilityService,
    private customersService: CustomersService,
    private propertyService: PropertyService,
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.drawerName = this.pickerDrawerName ? this.pickerDrawerName : this.drawerName;
    this.drawerName = this.drawerName + uuidv4();
    this.initDependencies();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  initDependencies(): void {
    if (this.module === 'RECURRENCE_JOB_MASTER') {
      //This phrase might get changed. Once it is confirmed, we will move this to localization.
      this.recurringJobInfoBubble =`
      1. Recurring jobs series that:
          a. Shares the cadence of the recurring route viz., daily, weekly, monthly
          b. Has its last instance before the recuring route
      2. Jobs with valid geographical coordinates (from the map)
      `;
    }
    else {
      this.recurringJobInfoBubble = null;
    }
  }

  isSubmitButtonDisabled(): boolean {
    let disableButton: boolean = false;
    let isNewValueSelected = true;
    this.selectedValueUids = (this.selectedValue?.length > 0) ? this.selectedValue?.map(item => item?.[this.pickerConfig[this.module]?.compareWith]) : [];
    if((this.selectedValueUids?.length === this.previousValueUids?.length) && (this.selectedValueUids?.length === 0) && (this.previousValueUids?.length === 0)){
      isNewValueSelected = false;
    }
    if(isNewValueSelected === false){
      disableButton = true;
    }
    return disableButton;
  }

  eventEmitHandler(event: any): void {
    this.selectedValue = event.value ?? this.selectedValue;
    if(this.options.selectOption === 'select' && this.options.showPreSelectedValue){
      this.preSelectedValue = this.getAssociatedModuleName(this.module, this.selectedValue[0]);
      this.preSelectedValuesIcon = this.getAssociatedModuleIcon(this.module);
    }
    this.pagination.totalRecords = event.totalRecords ?? this.pagination.totalRecords;
    this.pagination.pageIndex = event.pageIndex ?? this.pagination.pageIndex;
    this.searchKey = event.searchKey ?? this.searchKey;
    this.eventPageIndex = event.pageIndex ?? this.eventPageIndex;
    this.eventSortBy = event.sortBy ?? this.eventSortBy;
    this.eventSortType = event.sortType ?? this.eventSortType;
    if(this.options.selectOption === 'multiSelect' && (this.viewMode !== 'New')){
      this.isButtonDisabled = this.isSubmitButtonDisabled();
    }
    if (!this.utilityService.isEmptyOrUndefined(event.showSelectedItems)) {
      this.showSelectedItems = event.showSelectedItems;
    }
    if (!this.utilityService.isEmptyOrUndefined(event.filter)) {
      this.filter = event.filter;
    }
    if (!this.utilityService.isEmptyOrUndefined(event.searchKey)) {
      if (this.viewMode === 'Custom') {
        this.customTabSearchKey = event.searchKey;
      } else {
        this.eventSearchKey = event.searchKey;
      }
    }
    this.eventMaxSelect = event.maxSelectReached ?? this.eventMaxSelect;
  }

  formValidationHandler(isValid: boolean): void {
    this.eventSubmit = isValid;
  }

  newModeOperation(event: any): void {
    if (event.value) {
      this.updateSelectedValue(event.value);
    }
    this.saveValue();
  }

  updateSelectedValue(value: any[]): void {
    if (this.selectedValue?.length && this.options?.selectOption === PickerSelectOptions.multiSelect) {
      this.selectedValue = [...this.selectedValue,...value];
    } else {
      this.selectedValue = value;
    }
  }

  drawerOpenedChanged(isOpened: boolean): void {
    if (isOpened) {
      this.openDataPicker();
    } else {
      this.isDrawerOpened = false;
      this.eventEmitter.emit({ drawerClosed: true });
    }
  }

  openDataPicker(): void {
    this.updateViewMode();
    this.previousValueUids = (this.filter?.length > 0) ? this.filter.map( item => item?.[this.pickerConfig[this.module]?.compareWith]) : [] ;
    this.isCategoryEnabled = (this.options?.filters?.enableCategory !== false && this.module === 'CUSTOMER') || this.options?.filters?.enableCategory;
    this.dataUrl = this.baseUrl + this.pickerConfig[this.module].dataUrl;
    this.tabs = this.pickerConfig[this.module].tabs;
    this.footerCheckboxValue = this.options?.enableFooterCheckbox?.defaultValue || this.footerCheckboxValue;
    if (!(this.options?.data && !this.options?.enableDataTab)) {
      this.preloadFilterValues();
      this.filterByMenuList = this.getFilterByMenuList();
      this.updatePickerFilterVisibility();
    }
    if (this.module === 'RECURRENCE_JOB_MASTER') {
      this.filterFormGroup?.controls?.showAllJobs?.setValue(false);
    }
    this.isDrawerOpened = true;
    this.cdRef.detectChanges();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null; // Reset the variable
    }
    this.timeoutId = setTimeout(() => {
      if(!this.utilityService.isEmptyOrUndefined(this.searchField) && !this.utilityService.isEmptyOrUndefined(this.searchKey)){
        this.searchField?.nativeElement?.focus();
      }
    },500);
  }

  updatePickerFilterVisibility(): void {
    if (this.isExistingMode() && this.hasFilterValue) {
      this.changePickerFilterVisibility();
    }
  }

  updateViewMode(): void {
    let viewMode: string = 'Existing';
    if (this.options.showQuickCreateOnly) {
      viewMode = 'New';
    } else if (this.options.showCustomDataOnly || (this.options?.data?.length && this.options?.enableDataTab) || (this.options?.data && !this.options?.enableDataTab)) {
      viewMode = 'Custom';
    }
    this.changeViewMode(viewMode);
  }

  changeViewMode(mode: string): void {
    if (this.viewMode !== mode) {
      const isCustomModeChanged: boolean = this.viewMode === 'Custom' && mode === 'Existing';
      this.viewMode = mode;
      this.eventFormReset = this.viewMode === 'New';
      this.eventListData = this.viewMode === 'Custom' ? this.options.data || [] : null;
      this.searchKey = this.viewMode === 'Custom' ? this.customTabSearchKey : this.eventSearchKey;
      if (this.isInitialVisibilityChange) {
        this.updatePickerFilterVisibility();
      } else if (isCustomModeChanged && this.filterVisible) {
        this.updateSelectedModuleFilter(this.selectedModuleFilter);
        this.updateModuleFilterSelectedValue();
      }

      if(this.options.selectOption === 'multiSelect'){
        if(this.viewMode === 'New'){
          this.isButtonDisabled = false;
        }else{
          this.isButtonDisabled = this.isSubmitButtonDisabled();
        }
      }
    }
  }

  isListMode(): boolean {
    return this.viewMode === 'Existing' || this.viewMode === '' || this.viewMode === 'Custom';
  }

  isExistingMode(): boolean {
    return this.viewMode === 'Existing' || this.viewMode === '';
  }

  setTabClasses(mode: string): any {
    return {
      'border-indigo-500 text-indigo-600': this.viewMode === mode,
      'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': this.viewMode !== mode
    };
  }

  updateInpectionFormUsage(event: any): void {
    if (event?.target) {
      this.footerCheckboxValue = event?.target?.checked ? true : false;
    }
  }

  triggerSearch(searchKey: any): void {
    if (this.viewMode === 'Custom') {
      this.customTabSearchKey = searchKey;
    } else {
      this.eventPageIndex = 0;
      this.eventSearchKey = searchKey;
    }
  }

  onPageEvent(event: any): void {
    this.pagination.pageIndex = event.pageIndex;
    this.eventPageIndex = this.pagination.pageIndex;
  }

  chooseValue(): void {
    if (this.isListMode()) {
      this.saveValue();
    } else {
      this.eventSubmit = true;
    }
  }

  updateSubjectValue(): void{
    if(this.options?.enableFooterCheckbox?.enabled) {
      this.pickerService.setValue({ selectedValue: this.selectedValue, footerCheckboxValue: this.footerCheckboxValue });
    } else {
      this.pickerService.setValue(this.selectedValue);
    }
  }

  saveValue(): void {
    if((this.options.selectOption === 'multiSelect') && (this.viewMode !== 'New')){
      let hasDifferentValues = true;
      if(this.selectedValueUids?.length === this.previousValueUids?.length){
        // check if selected values uid's array has same value of previous value uid's array
        const newlySelectedValueUids = this.selectedValueUids.filter(uid => !this.previousValueUids?.includes(uid));
        hasDifferentValues = (newlySelectedValueUids?.length !== 0) ? true : false;
      }
      if(hasDifferentValues){
        this.updateSubjectValue();
      }
    }else{
      this.updateSubjectValue();
    }
    this.closeDataPicker();
  }

  closeDataPicker(): void {
    this.resetDataPicker();
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    drawer.close();
  }

  showSelectedItemsPanel(): void {
    this.showSelectedItems = true;
  }

  sortMenuClick(item: any): void {
    this.eventSortBy = item.actionType;
  }

  changeSortType(_event: any): void {
    this.eventSortType = this.eventSortType === 'ASC' ? 'DESC' : 'ASC';
  }

  setListCount(mode: string): BadgeOptions {
    const count: number = mode === 'Custom' ? this.options.data?.length || 0 : this.pagination.totalRecords || 0;
    const badgeOption: BadgeOptions = {
      type: 'PRIMARY',
      displayName: count > -1 ? count : 0,
      displayType: 'listingCount'
    };
    return badgeOption;
  }

  getSortItemDisplayKey(): string {
    let keyValue: string = '';
    if (this.pickerConfig[this.module]?.sortItems?.length) {
      const sortItems: any[] = this.pickerConfig[this.module]?.sortItems;
      sortItems.forEach((item: any) => {
        if (item.actionType === this.eventSortBy) {
          keyValue = item.displayKey ?? item.displayName;
        }
      });
    }
    return keyValue;
  }

  getHeaderDisplayKey(): string {
    return this.options.header?.displayKey ?? this.options.header?.displayName
      ?? pickerConfig[this.module]?.headerDisplayKey ?? '';
  }

  getFooterDisplayKey(): string {
    return this.options.footer?.displayKey ?? this.options.footer?.displayName ?? (this.isListMode() ?
      pickerConfig[this.module].footerSelectDisplayKey :
      pickerConfig[this.module].footerQuickCreateDisplayKey) ?? '';
  }

  resetDataPicker(): void {
    this.showSelectedItems = false;
    this.isCategoryEnabled = false;
    this.selectedValue = [];
    this.viewMode = '';
    this.pagination.pageIndex = 0;
    this.dataUrl = '';
    this.tabs = [];
    this.searchKey = '';
    this.filter = null;
    this.filterFormGroup = null;
    this.hasFilterValue = false;
    this.filterVisible = false;
    this.isInitialVisibilityChange = true;
    this.eventSearchKey = '';
    this.eventPageIndex = 0;
    this.eventFormReset = false;
    this.eventSubmit = false;
    this.eventSortBy = undefined;
    this.eventSortType = undefined;
    this.eventListData = null;
    this.footerCheckboxValue = false;
    this.isButtonDisabled = false;
    this.previousValueUids = [];
    this.selectedValueUids = [];
    this.selectedDateRange = null;
    this.pagination = {
      totalRecords: -1,
      pageIndex: 0,
      pageSize: 10
    };
  }

  getSelectionDisable(): any {
    if (this.options.selectionDisableBasedOn) {
      return {
        selectionDisableBasedOn: this.options.selectionDisableBasedOn,
        elementId: this.options.elementID,
        tooltipText: this.options.tooltipText
      };
    }
    return null;
  }

  resetSelectedItem(): void {
    if (this.filter) {
      this.selectedValue = [];
      this.saveValue();
    } else {
      this.closeDataPicker();
    }
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer?.open() : this.closeDataPicker();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openPicker?.previousValue !== undefined) {
      this.toggleDrawer(changes?.openPicker.currentValue);
    }
  }

  setConflictFilter(): void{
   const showAllJobs = this.filterFormGroup.get('showAllJobs').value;
   if(showAllJobs === null){
    this.filterFormGroup.get('showAllJobs').setValue(true);
   }else{
    this.filterFormGroup.get('showAllJobs').setValue(!showAllJobs);
   }
  }

  /*** Job Filter - Start ***/
  preloadFilterValues(): void {
    this.filterFormGroup = this.formBuilder.group({
      dateRange: new UntypedFormControl(null),
      assignedStatus: new UntypedFormControl(''),
      jobCategory: new UntypedFormControl(''),
      assignedEmployee: new UntypedFormControl(null),
      assetStatus: new UntypedFormControl(''),
      moduleBasedFilterValue: new UntypedFormControl(null),
      showAllJobs: new UntypedFormControl(null)
    });
    if (this.isCategoryEnabled) {
      this.getJobCategory();
    }
    if (this.options?.filters?.enableAssignEmployee) {
      this.setPreLoadedValueToLookUp();
    }
  }

  changePickerFilterVisibility(): void {
    this.filterVisible = !this.filterVisible;
    if (this.isInitialVisibilityChange && this.filterVisible) {
      this.isInitialVisibilityChange = false;
      if (this.filterByMenuList.length) {
        setTimeout(() => {
          this.updateSelectedModuleFilter(this.filterByMenuList.find((menu: any) => menu.selectedValue) || this.filterByMenuList[0]);
        }, 100);
      }
    } else if (this.filterVisible) {
      this.updateModuleFilterSelectedValue();
    }
  }

  selectDateRange(event: any): void {
    if (event.target?.className?.indexOf('clear-date-range') > -1) {
      return null;
    }
    const dateRangeDialog: any = this.zuperDialogService.openCustom(DateRangeComponent, {
      disableClose: true,
      dismissible: false,
      extraClass: 'date-range',
      hasBackdrop: true,
      data: { ...this.selectedDateRange, allowMaxDate: false }
    });
    dateRangeDialog.afterClosed().subscribe((data: any) => {
      if (data.result) {
        this.selectedDateRange = {
          startDate: dayjs(data?.dateRange?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          endDate: dayjs(data?.dateRange?.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        };
        this.filterFormGroup.get('dateRange').setValue(this.selectedDateRange);
      }
    });
  }

  clearDateRange(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.selectedDateRange = null;
    this.filterFormGroup.get('dateRange').setValue(null);
  }

  getJobCategory(): void {
    let url: string = null;
    let payload: any = {};

    if (this.module === 'JOB' || this.module === 'RECURRENCE_JOB_MASTER') {
      url = this.pickerService.pickerAPIUrls.jobsCategoryUrl;
    } else if (this.module === 'CUSTOMER') {
      url = this.pickerService.pickerAPIUrls.customersCategoryUrl;
      payload = {
        'sort_by': 'display_order'
      };
    }

    if (url) {
      this.dataCollectorService.getData(url, payload).subscribe((response: any) => {
        this.jobCategory = response.data;
      }, (_error: any) => {
      });
    }
  }

  getFilterByMenuList(): any[] {
    const menuList: any[] = [];
    if (this.options.filters?.filterByOrganization?.enabled) {
      this.hasFilterValue = this.options.filters?.filterByOrganization?.selectedValue ? true : this.hasFilterValue;
      const filterKey = this.options.filters?.filterByOrganization?.filterKey ?? (this.module === 'JOB' ? 'filter.customer_organization' : 'filter.organization');
      menuList.push({
        type: 'ORGANIZATION',
        filterKey: filterKey,
        displayName: 'Filter By Organization',
        displayKey: 'text.filter_by_organization',
        bindValue: 'organization_uid',
        placeholderKey: 'choose.organization',
        templateValue: '{{organization_name}}',
        selectedValue: this.options.filters?.filterByOrganization?.selectedValue ?? null,
        url: this.pickerService.pickerAPIUrls.organizationUrl,
        isDisabled: this.options.filters?.filterByOrganization?.valueDisabled ?? false
      });
    }
    if (this.options.filters?.filterByCustomer?.enabled) {
      this.hasFilterValue = this.options.filters?.filterByCustomer?.selectedValue ? true : this.hasFilterValue;
      menuList.push({
        type: 'CUSTOMER',
        filterKey: 'filter.customer',
        displayName: 'Filter By Customer',
        displayKey: 'text.filter_by_customer',
        bindValue: 'customer_uid',
        placeholderKey: 'text.choose_customer',
        templateValue: '{{customer_first_name}}',
        selectedValue: this.options.filters?.filterByCustomer?.selectedValue ?? null,
        url: this.pickerService.pickerAPIUrls.customerUrl,
        isDisabled: this.options.filters?.filterByCustomer?.valueDisabled ?? false
      });
    }
    if (this.options.filters?.filterByProperty?.enabled) {
      this.hasFilterValue = this.options.filters?.filterByProperty?.selectedValue ? true : this.hasFilterValue;
      menuList.push({
        type: 'PROPERTY',
        filterKey: 'filter.property',
        displayName: 'Filter By Property',
        displayKey: 'text.filter_by_property',
        bindValue: 'property_uid',
        placeholderKey: 'text.choose_property',
        templateValue: '{{property_name}}',
        selectedValue: this.options.filters?.filterByProperty?.selectedValue ?? null,
        url: this.pickerService.pickerAPIUrls.propertyUrl,
        isDisabled: this.options.filters?.filterByProperty?.valueDisabled ?? false
      });
    }
    return menuList;
  }

  filterByMenuClick(event: any): void {
    if (this.selectedModuleFilter?.type !== event?.type) {
      this.moduleFilterPageIndex = 1;
      this.updateSelectedModuleFilter(event);
    }
  }

  updateSelectedModuleFilter(moduleFilterValue: any, updateValue: boolean = true): void {
    let additionalparams: any = {};
    this.selectedModuleFilter = moduleFilterValue;
    if (this.selectedModuleFilter?.selectedValue && this.selectedModuleFilter?.selectedValue[this.selectedModuleFilter?.bindValue] && updateValue) {
      additionalparams['filter.' + this.selectedModuleFilter?.bindValue] = this.selectedModuleFilter?.selectedValue[this.selectedModuleFilter?.bindValue];
    }
    if(moduleFilterValue.type === 'ORGANIZATION'){
      additionalparams = {...additionalparams,'sort':'ASC','sort_by':'organization_name'};
    }
    if (this.module === 'ASSETS') {
      const params: any = this.getAssetFilterParams();
      additionalparams = params ? { ...additionalparams, ...params } : additionalparams;
    }
    this.moduleFilterPreloadedValue = [];
    this.setModuleFilterPreLoadedValueToLookUp(additionalparams, updateValue);
  }

  updateModuleFilterSelectedValue(): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.selectedModuleFilterValue ? this.moduleBasedFilter?.select({ value: this.selectedModuleFilterValue }) : this.moduleBasedFilter?.clearModel();
      this.moduleBasedFilter.setDisabledState(this.selectedModuleFilter?.isDisabled || false);
  }

  moduleFilterClear(): void{
    if(this.module === 'PROPERTY'){
      this.customersService.selectedOrganizationPropertyPickerFilterValue.next(null);
      if(this.options.filters.filterByOrganization.getDataWhenCleared){
        this.updateSelectedModuleFilter(this.selectedModuleFilter, false);
      }
    }
    if(this.module === 'CUSTOMER' && this.options?.fromModule === 'PROPERTY'){
      this.propertyService.selectedOrganizationCustomerPickerFilterValue.next(null);
    }
  }

  moduleFilterValueChange(event: any): void {    
    const filterValue = this.setModuleBasedFilterControlValue(event);
    if (filterValue !== null && this.module === 'PROPERTY') {
      this.customersService.selectedOrganizationPropertyPickerFilterValue.next(event);
    }
    if (filterValue !== null && this.module === 'CUSTOMER' && this.options?.fromModule === 'PROPERTY') {
      this.propertyService.selectedOrganizationCustomerPickerFilterValue.next(event);
    }
    if (this.module === 'CUSTOMER' && this.options?.fromModule === 'PROPERTY' && this.options.filters.filterByOrganization.enabled
      && this.utilityService.isEmptyOrUndefined(event)) {
      filterValue.push({ key: 'filter.customer_organization', value: null })
    }
    this.filterFormGroup.get('moduleBasedFilterValue').setValue(filterValue);
  }

  setModuleBasedFilterControlValue(dataValue: any): any[] {
    const controlValues: any[] = [];
    this.filterByMenuList.forEach((item: any) => {
      let value: any = null;
      if (this.selectedModuleFilter?.type === item.type && dataValue && dataValue[this.selectedModuleFilter?.bindValue]) {
        value = dataValue[this.selectedModuleFilter?.bindValue];
      }
      controlValues.push({
        key: item.filterKey,
        value: value
      });
    });
    return controlValues;
  }

  getAssetFilterParams(): any {
    const orgMenuItem: any = this.filterByMenuList.find(item => item.type === 'ORGANIZATION');
    if (this.selectedModuleFilter?.type === 'CUSTOMER' && orgMenuItem) {
      return {
        'filter.customer_organization': orgMenuItem?.selectedValue ? orgMenuItem?.selectedValue[orgMenuItem?.bindValue] : ''
      };
    } else if (this.selectedModuleFilter?.type === 'ORGANIZATION') {
      return {
        'filter.organization_uid': orgMenuItem?.selectedValue ? orgMenuItem?.selectedValue[orgMenuItem?.bindValue] : ''
      };
    } else if (this.selectedModuleFilter?.type === 'CUSTOMER') {
      const selectedValue: any = this.selectedModuleFilter?.selectedValue;
      return {
        'filter.customer_uid': selectedValue ? selectedValue[this.selectedModuleFilter?.bindValue] : ''
      };
    } else if (this.selectedModuleFilter?.type === 'PROPERTY') {
      const cusMenuItem: any = this.filterByMenuList.find(item => item.type === 'CUSTOMER');
      if (cusMenuItem?.selectedValue) {
        return {
          'filter.customer': cusMenuItem?.selectedValue && cusMenuItem?.bindValue ? cusMenuItem.selectedValue[cusMenuItem.bindValue] : '',
        };
      } else if (orgMenuItem?.selectedValue) {
        return {
          'filter.organization': orgMenuItem?.selectedValue && orgMenuItem?.bindValue ? orgMenuItem?.selectedValue[orgMenuItem?.bindValue] : ''
        };
      }
    }
    return null;
  }

  onModuleFilterLookupScrollEnd(): void {
    if (this.moduleFilterTotalPageCount >= this.moduleFilterPageIndex + 1) {
      this.moduleFilterPageIndex = this.moduleFilterPageIndex + 1;
      this.filterLookupLoading = true;
      let additionalParams: any = null;
      if (this.module === 'ASSETS') {
        additionalParams = this.getAssetFilterParams();
      }
      this.setModuleFilterPreLoadedValueToLookUp(additionalParams);
    }
  }

  setModuleFilterPreLoadedValueToLookUp(additionalparams: any,updateValue: boolean = true): void {
    let paramObj: any = {
      'page': this.moduleFilterPageIndex,
      'filter.keyword': this.moduleFilterSearchTerm
    };
    if (additionalparams) {
      paramObj = { ...paramObj, ...additionalparams };
    }
    const url: string = this.selectedModuleFilter?.url;
    if (url) {
      this.dataCollectorService.getData(url, paramObj).subscribe((response: any) => {
        const list: any[] = this.createLookupTemplateList(response.data, this.selectedModuleFilter?.templateValue);
        this.moduleFilterTotalPageCount = response.total_pages;
        this.moduleFilterPreloadedValue = this.moduleFilterPreloadedValue.length ? [...this.moduleFilterPreloadedValue, ...list] : list;
        if (additionalparams) {
          this.selectedModuleFilterValue = null;
          if (this.selectedModuleFilter?.selectedValue && this.selectedModuleFilter?.bindValue) {
            const bindValue: string = this.selectedModuleFilter?.bindValue;
            this.selectedModuleFilterValue = this.moduleFilterPreloadedValue.find(value => value[bindValue] === this.selectedModuleFilter?.selectedValue[bindValue]);
          }
          if(updateValue){
            this.updateModuleFilterSelectedValue();
          }
        }
        this.loadModuleFilterLookupValues();
      });
    }
  }

  loadModuleFilterLookupValues(): any {
    this.filterLookupLoading = false;
    this.moduleFilterListValue$ = concat(
      of(this.moduleFilterPreloadedValue), this.moduleFilterValueSubject$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.filterLookupLoading = true),
        tap(() => this.moduleFilterPageIndex = 1),
        switchMap((term: any) => {
          term = term ?? '';
          return this.setModuleFilterListValue(term).pipe(
            catchError(() => of(this.moduleFilterPreloadedValue)),
            tap(() => this.filterLookupLoading = false));
        })
      )
    );
  }

  setModuleFilterListValue(term = ''): any {
    let paramObj: any = {
      'page': this.moduleFilterPageIndex,
      'filter.keyword': term
    };
    return this.dataCollectorService.getData(this.selectedModuleFilter?.url, paramObj)
      .pipe(map((response: any) => {
        this.moduleFilterTotalPageCount = response.total_pages;
        const list: any[] = this.createLookupTemplateList(response.data, this.selectedModuleFilter?.templateValue);
        this.moduleFilterSearchTerm = term;
        this.moduleFilterPreloadedValue = [...list];
        return list;
      }
      ));
  }

  createLookupTemplateList(data: any[], templateValue: string): any[] {
    const template = _.template(templateValue);
    return data.map((key) => {
      key.displayValue = template(key);
      return key;
    });
  }

  constructLookupList(data: any[]): any {
    return this.createLookupTemplateList(data, '{{first_name}} {{last_name}}');
  }

  appendValueToItems(): void {
    if (this.totalPages >= this.pageSize + 1) {
      this.pageSize = this.pageSize + 1;
      this.lookupLoading = true;
      this.setPreLoadedValueToLookUp();
    }
  }

  setPreLoadedValueToLookUp(): void {
    const paramObj: any = {
      'page': this.pageSize,
      'filter.keyword': this.searchTerm
    };
    this.dataCollectorService.getData(this.pickerService.pickerAPIUrls.userListUrl, paramObj).subscribe((response: any) => {
      this.preloadedValue = this.preloadedValue.length ? [...this.preloadedValue, ...this.constructLookupList(response.data)] :
        this.constructLookupList(response.data);
      this.totalPages = response.total_pages;
      this.lookupLoading = false;
      this.loadLookupValues();
    });
  }

  setListValue(term = ''): any {
    const paramObj: any = {
      'page': this.pageSize,
      'filter.keyword': term
    };
    if (term) {
      return this.dataCollectorService.getData(this.pickerService.pickerAPIUrls.userListUrl, paramObj)
        .pipe(map((response: any) => {
          this.searchTerm = term;
          this.preloadedValue = this.constructLookupList(response.data);
          return this.constructLookupList(response.data);
        }
        ));
    } else {
      this.lookupLoading = false;
    }
  }

  isMaxSelectionLimit(): boolean {
    if(this.eventMaxSelect) {
      return true;
    }
    else {
      return false;
    }

  }

  getAssociatedModuleName(module: string, associatedDetails: any): string {
    if(!_.isEmpty(associatedDetails)){
        switch(module){
          case 'CUSTOMER':
              return `${associatedDetails?.customer_first_name} ${associatedDetails?.customer_last_name ?? ''}`;
          case 'ORGANIZATION':
              return `${associatedDetails?.organization_name}`;
        }
    }
  }

  getAssociatedModuleIcon(module: string): string {
    return ModuleIcon[moduleKey[module]];
  }

  private loadLookupValues(): any {
    this.lookupLoading = false;
    this.listValue$ = concat(
      of(this.preloadedValue), this.valueSubject$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.lookupLoading = true),
        tap(() => this.pageSize = 1),
        switchMap((term: any) => {
          if (term) {
            return this.setListValue(term).pipe(
              catchError(() => of(this.preloadedValue)),
              tap(() => this.lookupLoading = false));
          } else {
            this.lookupLoading = false;
            return [];
          }
        })
      )
    );
  }
  /*** Job Filter - End ***/

}
